﻿//==========================================================================================================
// Copyright (C) Nore Technology AB. All Rights Reserved.
//==========================================================================================================

//-------------------------------------------------------------------------------------
// Imports
//-------------------------------------------------------------------------------------

import * as React from "react";
import type { RegisterPageCustomizations } from "~base/Pages/Account/Register";
import { RegisterPageDefaultCustomization } from "~base/Pages/Account/Register";
import SoPLogo from "~irad-resources/Logos/SoPLogoMask.svg?url";

//-------------------------------------------------------------------------------------
// Exports
//-------------------------------------------------------------------------------------

const customStyling = {
    header: {
        padding: "25px 33px 0px 8px",
    },
};

const filterFunc: (languages: string[]) => string[] = (languages: string[]) => {
    return languages.map((lang) => (lang === "en-NL" ? "en-US" : lang));
};

export default {
    ...RegisterPageDefaultCustomization,
    showEmail: false,
    showPhoneNumber: false,
    showVerksamhetsort: false,
    customStyles: customStyling,
    differentLanguageSelection: true,
    userInfoCustomization: {
        pictureFrame: (
            <img
                src={SoPLogo}
                style={{
                    width: "50px",
                    paddingTop: "5px",
                }}
            />
        ),
    },
    languageFilterFunction: filterFunc,
} as RegisterPageCustomizations;
